// extracted by mini-css-extract-plugin
export var closeButton = "_25-3";
export var header = "_25-0";
export var link = "_25-1";
export var retryButton = "_25-2";